import jssVariables from ".";

const modalStyles = {
  modal: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100%",
    zIndex: 9999,
    background: "rgba(0,0,0,0.3)",
    backdropFilter: "blur(5px)",
  },
  card: {
    display: "grid",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    background: "white",
    borderRadius: jssVariables.border_radius,
  },
  cardBody: {
    display: "grid",
    gridGap: jssVariables.normal_gap,
    padding: jssVariables.normal_gap,
  },
  cardActions: {
    display: "grid",
    padding: jssVariables.normal_gap,
    gridAutoFlow: "column",
    gridGap: `calc(${jssVariables.normal_gap} / 2)`,
  },
};

export const modalGenericStyles = {
  "@keyframes modl": {
    from: {
      background: "rgba(0,0,0,0)",
      backdropFilter: "blur(0px)",
    },
    to: {
      background: "rgba(0,0,0,0.3)",
      backdropFilter: "blur(5px)",
    },
  },
  modal: {
    ...modalStyles.modal,
    animationDuration: ".5s",
    animationName: "$modl",
  },
  card: modalStyles.card,
  cardHeader: modalStyles,
  cardBody: modalStyles.cardBody,
  cardActions: modalStyles.cardActions,
  loader: modalStyles,
};
